// alertstate.ts — the transient in-game alert holder (game/alertcontrol.cpp), extracted
// from misccontrols.ts (canvas-removal R3). NOT a Control: the canvas in-game AlertControl
// is gone (forms.ini-elimination Phase 3) — AlertState is the sole source, read each frame
// by the DOM SimUIView. Depends only on the timer mgr, so it lives in its own neutral module.

import { CallbackTimer, TimerMgr } from './timer.ts';

// alertcontrol.cpp:35
const kfTimerSet = 1;
// alertcontrol.cpp:54 — 400 ticks, or 4 seconds
const kctInterval = 400;

// byte-identical to AlertControl: kctInterval=400 (4s), latest-wins re-arm
// (SetTimerRate if armed else AddTimer), OnTimer hides + drops.
export class AlertState {
  text = '';
  visible = false;
  private m_gtimm: TimerMgr;
  // alertcontrol.cpp:30-33 (ctor) — the timer bit is the holder's own flag (the C++
  // packed it into m_wf; here AlertState is not a Control, so it stands alone).
  private m_wf = 0;
  private m_tmr = new CallbackTimer((t) => this.OnTimer(t));

  constructor(gtimm: TimerMgr) {
    this.m_gtimm = gtimm;
  }

  // game/alertcontrol.cpp:36-40 — ~AlertControl (drop the timer if armed)
  Dispose(): void {
    if (this.m_wf & kfTimerSet) this.m_gtimm.RemoveTimer(this.m_tmr);
  }

  // game/alertcontrol.cpp:55-67 — AddText: set the text, arm-or-re-arm the 4s timer
  // (latest-wins: SetTimerRate resets the trigger if already armed, else AddTimer),
  // and raise visible.
  AddText(psz: string): void {
    this.text = psz;
    if (this.m_wf & kfTimerSet) {
      this.m_gtimm.SetTimerRate(this.m_tmr, kctInterval);
    } else {
      this.m_gtimm.AddTimer(this.m_tmr, kctInterval);
      this.m_wf |= kfTimerSet;
    }
    this.visible = true;
  }

  // game/alertcontrol.cpp:69-77 — on timer firing the status should no longer be
  // displayed: hide, remove the timer, clear the flag.
  OnTimer(_tCurrent: number): void {
    this.visible = false;
    this.m_gtimm.RemoveTimer(this.m_tmr);
    this.m_wf &= ~kfTimerSet;
  }
}

// Repointed to the SimUILayer's canonical AlertState (Phase 1): the host hands the
// holder; the DOM SimUIView reads it each frame. (Phase 3): the canvas in-game
// AlertControl is GONE — the holder is the sole source, read only by the DOM push.
export function ShowAlert(pAlert: AlertState | null, psz: string): void {
  if (pAlert === null) return;
  pAlert.AddText(psz);
}
